import { LuPaperclip } from "react-icons/lu";

const FileUploadButton = ({ label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center gap-6 p-2 font-medium leading-none bg-white border-2 min-h-12 w-60 text-neutral-900 border-neutral-600 rounded-2xl "
    >
      <LuPaperclip className="text-xl text-gray-c-700" />
      {/* {label} */}
      파일 업로드
    </button>
  );
};

export default FileUploadButton;
